import { render, staticRenderFns } from "./DetailsInspectionOutputBox.vue?vue&type=template&id=2896d673"
import script from "./DetailsInspectionOutputBox.vue?vue&type=script&lang=ts"
export * from "./DetailsInspectionOutputBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports